import {
	GridItem,
	SimpleGrid,
} from '@chakra-ui/react';

import { NextImageWithSkeleton } from '@packages/chakra-v3';

type ProductImageGalleryProps = {
	coverImage: string | undefined;
	images:     string[];
};

const ProductImageGallery = ({
	coverImage,
	images,
}:  ProductImageGalleryProps) => {
	return (
		<SimpleGrid
			columns={2}
			flex={1}
			gap={4}
			h={'fit-content'}
		>
			<GridItem colSpan={2} h={'fit-content'}>
				<NextImageWithSkeleton
					alt={'Product thumbnail'}
					aspectRatio={'portrait'}
					src={coverImage ?? ''}
				/>
			</GridItem>
			{images.map((image, index) => (
				<GridItem key={`${image}-${index}`} h={'fit-content'}>
					<NextImageWithSkeleton
						alt={'Product thumbnail'}
						aspectRatio={'square'}
						src={image}
					/>
				</GridItem>
			))}
		</SimpleGrid>
	);
};

export default ProductImageGallery;